angular.module("warsApp.filters").filter('defaultText', function () {
    return function (value, defaultValue) {
        return isUndefinedNullOrWhiteSpace(value)
            ? defaultValue
            : value;
    };
});